export default function makeDefaultUDPolicy(forbiddenCategories, isolatedCategories) {
    return {
        name: '',
        enabled: false,
        userGroups: [],
        isolatedCategories: [...isolatedCategories],
        neverIsolate: [],
        allowExitIsolationFromSafeState: true,
        displayExitWarning: true,
        exitWarningText: '',
        dlp: {
            defaults: {
                allInput: false,
                clipboardPaste: false,
                pasteLimitEnabled: false,
                pasteLimit: -1,
            },
            domains: [],
        },
        contentFiltering: {
            filterContent: true,
            whitelistThreatSim: true,
            allCategories: [],
            forbiddenCategories: [...forbiddenCategories],
            webFilterList: {
                blacklistRules: [],
                whitelistRules: [],
            },
        },
        alwaysRedirectIgnoringScan: true,
        scanTimeout: 420,
        neverIsolateAfterRedirect: true,
    };
}
